import React, { useCallback } from 'react'
import { Text } from '@usap/uicomponents'
import {
  OrderDetailsButtonContainer,
  OrderDetailsCtaWmo
} from './style/buttonWMO.css'
import LifetimeReplacementWMO from './LifetimeReplacementWMO'
import { returnType } from './type'

const ViewReturnDetailsButton = ({ data, isDesktop }) => {
  const {
    type,
    showReturn,
    navigateToRMA,
    partNumber,
    orderId,
  } = data

  const actionButtonClick = useCallback(() => {
    navigateToRMA(orderId, partNumber)
  }, [orderId, partNumber, navigateToRMA])

  if (type === returnType.lifetime) {
    return <LifetimeReplacementWMO data={data} />
  }

  return (
    <OrderDetailsButtonContainer>
      <OrderDetailsCtaWmo
        custom
        hideBorder
        onClick={actionButtonClick}
        label={
          <Text size={isDesktop ? "16px" : "14px"} color={"dark-2"}>
            Return Item
          </Text>
        }
      />
    </OrderDetailsButtonContainer>
  );
}

export default ViewReturnDetailsButton
